/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { emptyGraphqlApi } from '../emptyApi';
export type AccessoryGesture =
  | 'DOUBLE_PRESS'
  | 'LONG_PRESS'
  | 'SINGLE_PRESS'
  | 'TRIPLE_PRESS'
  | '%future added value';

export type AccessoryOperationalStatus =
  | 'DISABLED'
  | 'NOT_SYNCED'
  | 'OFFLINE'
  | 'OPERATIONAL'
  | 'UNKNOWN'
  | '%future added value';

export type AttendanceStatus =
  | 'ATTENDED'
  | 'ATTENDING'
  | 'NOT_ATTENDED'
  | '%future added value';

export type ClimateAlarmCurrentStatus =
  | 'ALARM'
  | 'NO_DATA'
  | 'OK'
  | 'RECOVER'
  | '%future added value';

export type ClimateAlarmMetric =
  | 'HUMIDITY'
  | 'TEMPERATURE'
  | '%future added value';

export type ClimateAlarmThresholdType =
  | 'GREATER_THAN'
  | 'GREATER_THAN_OR_EQUAL'
  | 'LESS_THAN'
  | 'LESS_THAN_OR_EQUAL'
  | '%future added value';

export type DateTimeFilters = {
  dateFrom?: string | null | undefined;
  dateTo?: string | null | undefined;
  since?: string | null | undefined;
  timeFrom?: string | null | undefined;
  timeTo?: string | null | undefined;
  timeZone?: string | null | undefined;
  until?: string | null | undefined;
};

export type IncidentFilters = {
  categories?: Array<string> | null | undefined;
  createdByPartners?: Array<string> | null | undefined;
  dateTime?: DateTimeFilters | null | undefined;
  hasCreator?: boolean | null | undefined;
  monitorIds?: Array<string | number> | null | undefined;
};

export type MonitorOperationalStatus =
  | 'DEACTIVATED'
  | 'DISABLED'
  | 'OFFLINE'
  | 'OPERATIONAL'
  | 'POWERED_OFF'
  | 'UNKNOWN'
  | '%future added value';

export type NoteFilters = {
  createdByPartners?: Array<string> | null | undefined;
  dateTime?: DateTimeFilters | null | undefined;
  hasCreator?: boolean | null | undefined;
  monitorIds?: Array<string | number> | null | undefined;
};

export type NotificationImportance =
  | 'DEFAULT'
  | 'HIGH'
  | 'LOW'
  | '%future added value';

export type ObservationFilters = {
  dateTime?: DateTimeFilters | null | undefined;
  monitorIds?: Array<string | number> | null | undefined;
};

export type PresenceFilters = {
  dateTime?: DateTimeFilters | null | undefined;
  monitorIds?: Array<string | number> | null | undefined;
  status?: PresenceStatus | null | undefined;
  verified?: boolean | null | undefined;
};

export type PresenceStatus =
  | 'CLOSED'
  | 'OPEN'
  | '%future added value';

type AccessoryStatusIndicatorAccessory_BridgeAccessory_Fragment = { operationStatus: AccessoryOperationalStatus };

type AccessoryStatusIndicatorAccessory_ButtonAccessory_Fragment = { operationStatus: AccessoryOperationalStatus };

type AccessoryStatusIndicatorAccessory_ClimateSensorAccessory_Fragment = { operationStatus: AccessoryOperationalStatus };

type AccessoryStatusIndicatorAccessory_GenericAccessory_Fragment = { operationStatus: AccessoryOperationalStatus };

export type AccessoryStatusIndicatorAccessoryFragment =
  | AccessoryStatusIndicatorAccessory_BridgeAccessory_Fragment
  | AccessoryStatusIndicatorAccessory_ButtonAccessory_Fragment
  | AccessoryStatusIndicatorAccessory_ClimateSensorAccessory_Fragment
  | AccessoryStatusIndicatorAccessory_GenericAccessory_Fragment
;

export type MonitorStatusIndicatorMonitorFragment = { operationStatus: MonitorOperationalStatus, charging: boolean | null };

export type CurrentAccountFragment = { id: string, features: Array<string> };

export type FetchCurrentAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchCurrentAccountQuery = { currentAccount: { id: string, features: Array<string> } | null };

export type DeviceOptionFragment = { id: string, name: string | null };

export type FetchDeviceOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchDeviceOptionsQuery = { currentAccount: { deviceOptions: { nodes: Array<{ id: string, name: string | null }> } } | null };

export type MonitorOptionFragment = { id: string, nickname: string | null };

export type FetchMonitorOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchMonitorOptionsQuery = { monitorOptions: { nodes: Array<{ id: string, nickname: string | null }> } };

export type FetchMonitorOptionQueryVariables = Exact<{
  id: string | number;
}>;


export type FetchMonitorOptionQuery = { monitorOption: { id: string, nickname: string | null } | null };

export type StaffOptionFragment = { id: string, name: string | null };

export type FetchStaffOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchStaffOptionsQuery = { currentAccount: { staffOptions: { nodes: Array<{ id: string, name: string | null }> } } | null };

export type StatusScreenNestedLocationFragment = { id: string, name: string | null };

export type StatusScreenNestedMonitorFragment = { id: string, nickname: string | null };

export type StatusScreenMonitorFragment = { __typename: 'Monitor', id: string, nickname: string | null, charging: boolean | null, operational: boolean, operationStatus: MonitorOperationalStatus, location: { id: string, name: string | null } | null, sounds: Array<{ slug: string | null, name: string | null, svg_icon_url: string | null }>, observations: Array<{ observation_type: string, sound: { slug: string | null, name: string | null, svg_icon_url: string | null } | null }> };

type StatusScreenAccessory_BridgeAccessory_Fragment = { __typename: 'BridgeAccessory', id: string, nickname: string | null, operational: boolean, operationStatus: AccessoryOperationalStatus, location: { id: string, name: string | null } | null, monitor: { id: string, nickname: string | null } | null, parentAccessory:
    | { id: string, operationStatus: AccessoryOperationalStatus }
    | { id: string, operationStatus: AccessoryOperationalStatus }
    | { id: string, operationStatus: AccessoryOperationalStatus }
    | { id: string, operationStatus: AccessoryOperationalStatus }
   | null };

type StatusScreenAccessory_ButtonAccessory_Fragment = { __typename: 'ButtonAccessory', id: string, nickname: string | null, operational: boolean, operationStatus: AccessoryOperationalStatus, gestureActions: Array<{ gesture: AccessoryGesture, action: string | null }>, latestCall:
    | { startAt: string }
    | { startAt: string }
   | null, location: { id: string, name: string | null } | null, monitor: { id: string, nickname: string | null } | null, parentAccessory:
    | { id: string, operationStatus: AccessoryOperationalStatus }
    | { id: string, operationStatus: AccessoryOperationalStatus }
    | { id: string, operationStatus: AccessoryOperationalStatus }
    | { id: string, operationStatus: AccessoryOperationalStatus }
   | null };

type StatusScreenAccessory_ClimateSensorAccessory_Fragment = { __typename: 'ClimateSensorAccessory', id: string, nickname: string | null, operational: boolean, operationStatus: AccessoryOperationalStatus, climate: { id: string, temperature: number | null, alarms: Array<{ id: string, metric: ClimateAlarmMetric, currentStatus: ClimateAlarmCurrentStatus, disabled: boolean, thresholdType: ClimateAlarmThresholdType, alarmThreshold: number }> } | null, location: { id: string, name: string | null } | null, monitor: { id: string, nickname: string | null } | null, parentAccessory:
    | { id: string, operationStatus: AccessoryOperationalStatus }
    | { id: string, operationStatus: AccessoryOperationalStatus }
    | { id: string, operationStatus: AccessoryOperationalStatus }
    | { id: string, operationStatus: AccessoryOperationalStatus }
   | null };

type StatusScreenAccessory_GenericAccessory_Fragment = { __typename: 'GenericAccessory', id: string, nickname: string | null, operational: boolean, operationStatus: AccessoryOperationalStatus, location: { id: string, name: string | null } | null, monitor: { id: string, nickname: string | null } | null, parentAccessory:
    | { id: string, operationStatus: AccessoryOperationalStatus }
    | { id: string, operationStatus: AccessoryOperationalStatus }
    | { id: string, operationStatus: AccessoryOperationalStatus }
    | { id: string, operationStatus: AccessoryOperationalStatus }
   | null };

export type StatusScreenAccessoryFragment =
  | StatusScreenAccessory_BridgeAccessory_Fragment
  | StatusScreenAccessory_ButtonAccessory_Fragment
  | StatusScreenAccessory_ClimateSensorAccessory_Fragment
  | StatusScreenAccessory_GenericAccessory_Fragment
;

export type FetchStatusScreenDataQueryVariables = Exact<{
  accountId: string | number;
}>;


export type FetchStatusScreenDataQuery = { account: { dashboard: { connectedDevicesCount: number, averageResponseTime: string | null, responseCount: number } | null, monitors: { nodes: Array<{ __typename: 'Monitor', id: string, nickname: string | null, charging: boolean | null, operational: boolean, operationStatus: MonitorOperationalStatus, location: { id: string, name: string | null } | null, sounds: Array<{ slug: string | null, name: string | null, svg_icon_url: string | null }>, observations: Array<{ observation_type: string, sound: { slug: string | null, name: string | null, svg_icon_url: string | null } | null }> }> }, accessories: { nodes: Array<
        | { __typename: 'BridgeAccessory', id: string, nickname: string | null, operational: boolean, operationStatus: AccessoryOperationalStatus, location: { id: string, name: string | null } | null, monitor: { id: string, nickname: string | null } | null, parentAccessory:
            | { id: string, operationStatus: AccessoryOperationalStatus }
            | { id: string, operationStatus: AccessoryOperationalStatus }
            | { id: string, operationStatus: AccessoryOperationalStatus }
            | { id: string, operationStatus: AccessoryOperationalStatus }
           | null }
        | { __typename: 'ButtonAccessory', id: string, nickname: string | null, operational: boolean, operationStatus: AccessoryOperationalStatus, gestureActions: Array<{ gesture: AccessoryGesture, action: string | null }>, latestCall:
            | { startAt: string }
            | { startAt: string }
           | null, location: { id: string, name: string | null } | null, monitor: { id: string, nickname: string | null } | null, parentAccessory:
            | { id: string, operationStatus: AccessoryOperationalStatus }
            | { id: string, operationStatus: AccessoryOperationalStatus }
            | { id: string, operationStatus: AccessoryOperationalStatus }
            | { id: string, operationStatus: AccessoryOperationalStatus }
           | null }
        | { __typename: 'ClimateSensorAccessory', id: string, nickname: string | null, operational: boolean, operationStatus: AccessoryOperationalStatus, climate: { id: string, temperature: number | null, alarms: Array<{ id: string, metric: ClimateAlarmMetric, currentStatus: ClimateAlarmCurrentStatus, disabled: boolean, thresholdType: ClimateAlarmThresholdType, alarmThreshold: number }> } | null, location: { id: string, name: string | null } | null, monitor: { id: string, nickname: string | null } | null, parentAccessory:
            | { id: string, operationStatus: AccessoryOperationalStatus }
            | { id: string, operationStatus: AccessoryOperationalStatus }
            | { id: string, operationStatus: AccessoryOperationalStatus }
            | { id: string, operationStatus: AccessoryOperationalStatus }
           | null }
        | { __typename: 'GenericAccessory', id: string, nickname: string | null, operational: boolean, operationStatus: AccessoryOperationalStatus, location: { id: string, name: string | null } | null, monitor: { id: string, nickname: string | null } | null, parentAccessory:
            | { id: string, operationStatus: AccessoryOperationalStatus }
            | { id: string, operationStatus: AccessoryOperationalStatus }
            | { id: string, operationStatus: AccessoryOperationalStatus }
            | { id: string, operationStatus: AccessoryOperationalStatus }
           | null }
      > } } | null };

export type SubscribeStatusScreenMonitorDataSubscriptionVariables = Exact<{
  accountId: string | number;
}>;


export type SubscribeStatusScreenMonitorDataSubscription = { monitorEventsCreated: { monitor: { id: string, charging: boolean | null, operational: boolean, operationStatus: MonitorOperationalStatus } | null } };

export type SubscribeStatusScreenStatusUpdatesDataSubscriptionVariables = Exact<{
  accountId: string | number;
}>;


export type SubscribeStatusScreenStatusUpdatesDataSubscription = { accountStatusUpdates:
    | { __typename: 'AccountStatusUpdatesSubscriptionAccessoryPayload', accessoryId: string, operational: boolean, operationStatus: AccessoryOperationalStatus, accountId: string }
    | { __typename: 'AccountStatusUpdatesSubscriptionClimateAlarmPayload', climateAlarmId: string, currentStatus: ClimateAlarmCurrentStatus, accountId: string }
    | { __typename: 'AccountStatusUpdatesSubscriptionClimatePayload', temperature: number | null, accountId: string, climateAccessoryId: string | null }
    | { __typename: 'AccountStatusUpdatesSubscriptionMonitorPayload', monitorId: string, charging: boolean | null, operational: boolean, accountId: string, monitorOperationStatus: MonitorOperationalStatus }
   };

export type FetchKanbanMonitorsQueryVariables = Exact<{
  accountId: string | number;
}>;


export type FetchKanbanMonitorsQuery = { account: { monitors: { nodes: Array<{ id: string, operational: boolean }> } } | null };

export type SubscribeKanbanMonitorsSubscriptionVariables = Exact<{
  accountId: string | number;
}>;


export type SubscribeKanbanMonitorsSubscription = { monitorEventsCreated: { monitor: { id: string, operational: boolean } | null } };

export type KanbanEventMonitorFragment = { id: string, nickname: string | null };

export type KanbanSoundEventFragment = { __typename: 'DashboardKanbanSoundEvent', attendanceStatus: AttendanceStatus, createdAt: string, notificationImportance: NotificationImportance | null, sound: { slug: string | null, name: string | null, svg_icon_url: string | null } | null, monitor: { id: string, nickname: string | null } | null };

export type KanbanAttendanceEventFragment = { __typename: 'DashboardKanbanAttendanceEvent', createdAt: string, attendanceStatus: AttendanceStatus, isPhysicalAttendance: boolean, monitor: { id: string, nickname: string | null } | null };

export type KanbanCallEventFragment = { __typename: 'DashboardKanbanCallEvent', createdAt: string, attendanceStatus: AttendanceStatus, monitor: { id: string, nickname: string | null } | null };

type KanbanEvent_DashboardKanbanAttendanceEvent_Fragment = { __typename: 'DashboardKanbanAttendanceEvent', createdAt: string, attendanceStatus: AttendanceStatus, isPhysicalAttendance: boolean, monitor: { id: string, nickname: string | null } | null };

type KanbanEvent_DashboardKanbanCallEvent_Fragment = { __typename: 'DashboardKanbanCallEvent', createdAt: string, attendanceStatus: AttendanceStatus, monitor: { id: string, nickname: string | null } | null };

type KanbanEvent_DashboardKanbanSoundEvent_Fragment = { __typename: 'DashboardKanbanSoundEvent', attendanceStatus: AttendanceStatus, createdAt: string, notificationImportance: NotificationImportance | null, sound: { slug: string | null, name: string | null, svg_icon_url: string | null } | null, monitor: { id: string, nickname: string | null } | null };

export type KanbanEventFragment =
  | KanbanEvent_DashboardKanbanAttendanceEvent_Fragment
  | KanbanEvent_DashboardKanbanCallEvent_Fragment
  | KanbanEvent_DashboardKanbanSoundEvent_Fragment
;

export type FetchKanbanScreenEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchKanbanScreenEventsQuery = { currentAccount: { dashboard: { kanban: { events: Array<
          | { __typename: 'DashboardKanbanAttendanceEvent', createdAt: string, attendanceStatus: AttendanceStatus, isPhysicalAttendance: boolean, monitor: { id: string, nickname: string | null } | null }
          | { __typename: 'DashboardKanbanCallEvent', createdAt: string, attendanceStatus: AttendanceStatus, monitor: { id: string, nickname: string | null } | null }
          | { __typename: 'DashboardKanbanSoundEvent', attendanceStatus: AttendanceStatus, createdAt: string, notificationImportance: NotificationImportance | null, sound: { slug: string | null, name: string | null, svg_icon_url: string | null } | null, monitor: { id: string, nickname: string | null } | null }
        > } | null } | null } | null };

export type SubscribeKanbanScreenEventsSubscriptionVariables = Exact<{
  accountId: string | number;
}>;


export type SubscribeKanbanScreenEventsSubscription = { dashboardKanbanEventsCreated:
    | { __typename: 'DashboardKanbanAttendanceEvent', createdAt: string, attendanceStatus: AttendanceStatus, isPhysicalAttendance: boolean, monitor: { id: string, nickname: string | null } | null }
    | { __typename: 'DashboardKanbanCallEvent', createdAt: string, attendanceStatus: AttendanceStatus, monitor: { id: string, nickname: string | null } | null }
    | { __typename: 'DashboardKanbanSoundEvent', attendanceStatus: AttendanceStatus, createdAt: string, notificationImportance: NotificationImportance | null, sound: { slug: string | null, name: string | null, svg_icon_url: string | null } | null, monitor: { id: string, nickname: string | null } | null }
   };

type IStatisticsDimensionGroupBy_StatisticsCategoricalDimension_Fragment = { __typename: 'StatisticsCategoricalDimension', key: string };

type IStatisticsDimensionGroupBy_StatisticsDateRangeDimension_Fragment = { __typename: 'StatisticsDateRangeDimension', key: string };

export type IStatisticsDimensionGroupByFragment =
  | IStatisticsDimensionGroupBy_StatisticsCategoricalDimension_Fragment
  | IStatisticsDimensionGroupBy_StatisticsDateRangeDimension_Fragment
;

export type IStatisticsCategoricalDimensionCategoryFragment = { label: string | null };

export type IStatisticsDimensionSortCategoryLabelFragment = { categories: Array<{ label: string | null }> | null };

export type IStatisticsDimensionDateRangeFragment = { from: string | null, to: string | null };

export type FetchAcousticsMonitorScreenIncidentListWidgetIncidentFragment = { id: string, category: string | null, locationDescription: string | null, note: string | null, occurredAt: string };

export type FetchAcousticsMonitorScreenIncidentListWidgetIncidentsQueryVariables = Exact<{
  filters?: IncidentFilters | null | undefined;
}>;


export type FetchAcousticsMonitorScreenIncidentListWidgetIncidentsQuery = { currentAccount: { incidents: { nodes: Array<{ id: string, category: string | null, locationDescription: string | null, note: string | null, occurredAt: string }> } } | null };

export type FetchAcousticsMonitorScreenNoteListWidgetNoteFragment = { id: string, title: string, content: string | null, category: string | null, submittedAt: string, createdByPerson:
    | { name: string | null }
    | { name: string | null }
   | null, createdByDevice: { name: string | null } | null };

export type FetchAcousticsMonitorScreenNoteListWidgetNotesQueryVariables = Exact<{
  filters?: NoteFilters | null | undefined;
}>;


export type FetchAcousticsMonitorScreenNoteListWidgetNotesQuery = { currentAccount: { notes: { nodes: Array<{ id: string, title: string, content: string | null, category: string | null, submittedAt: string, createdByPerson:
          | { name: string | null }
          | { name: string | null }
         | null, createdByDevice: { name: string | null } | null }> } } | null };

export type FetchAcousticsMonitorScreenObservationListWidgetObservationFragment = { id: string, observationType: string, startAt: string | null, endAt: string | null, createdAt: string, sound: { slug: string | null, name: string | null, svg_icon_url: string | null } | null };

export type FetchAcousticsMonitorScreenObservationListWidgetObservationsQueryVariables = Exact<{
  filters?: ObservationFilters | null | undefined;
}>;


export type FetchAcousticsMonitorScreenObservationListWidgetObservationsQuery = { currentAccount: { observations: { nodes: Array<{ id: string, observationType: string, startAt: string | null, endAt: string | null, createdAt: string, sound: { slug: string | null, name: string | null, svg_icon_url: string | null } | null }> } } | null };

export type FetchAcousticsOverviewScreenObservationListWidgetObservationFragment = { id: string, observationType: string, startAt: string | null, endAt: string | null, createdAt: string, monitor: { id: string, nickname: string | null } | null, sound: { slug: string | null, name: string | null, svg_icon_url: string | null } | null };

export type FetchAcousticsOverviewScreenObservationListWidgetObservationsQueryVariables = Exact<{
  filters?: ObservationFilters | null | undefined;
  first?: number | null | undefined;
}>;


export type FetchAcousticsOverviewScreenObservationListWidgetObservationsQuery = { currentAccount: { observations: { nodes: Array<{ id: string, observationType: string, startAt: string | null, endAt: string | null, createdAt: string, monitor: { id: string, nickname: string | null } | null, sound: { slug: string | null, name: string | null, svg_icon_url: string | null } | null }> } } | null };

export type FetchAcousticsScreenFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAcousticsScreenFilterOptionsQuery = { currentAccount: { statisticsDimensions: Array<
      | { __typename: 'StatisticsCategoricalDimension', key: string, field: string, categories: Array<{ key: string, label: string | null, node:
            | { __typename: 'BridgeAccessory' }
            | { __typename: 'ButtonAccessory' }
            | { __typename: 'Climate' }
            | { __typename: 'ClimateSensorAccessory' }
            | { __typename: 'Device' }
            | { __typename: 'GenericAccessory' }
            | { __typename: 'Incident' }
            | { __typename: 'Monitor', routines: Array<{ active: boolean, startTime: string, endTime: string }> }
            | { __typename: 'Note' }
            | { __typename: 'Observation' }
            | { __typename: 'Presence' }
            | { __typename: 'Sound' }
            | { __typename: 'User' }
           | null }> | null }
      | { __typename: 'StatisticsDateRangeDimension', from: string | null, to: string | null, key: string, field: string }
     | null> } | null };

export type FetchAidCallOverviewScreenFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAidCallOverviewScreenFilterOptionsQuery = { currentAccount: { statisticsDimensions: Array<
      | { __typename: 'StatisticsCategoricalDimension', key: string, field: string, categories: Array<{ key: string, label: string | null }> | null }
      | { __typename: 'StatisticsDateRangeDimension', from: string | null, to: string | null, key: string, field: string }
     | null> } | null };

export type FetchClimatesOverviewScreenClimatesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchClimatesOverviewScreenClimatesQuery = { account: { climates: { nodes: Array<{ id: string, accessory:
          | { nickname: string | null }
          | { nickname: string | null }
          | { nickname: string | null }
          | { nickname: string | null }
         | null, alarms: Array<{ thresholdType: ClimateAlarmThresholdType, metric: ClimateAlarmMetric, alarmThreshold: number, disabled: boolean }> }> } } | null };

type FetchClimatesScreenClimateSensorAccessory_BridgeAccessory_Fragment = { __typename: 'BridgeAccessory', id: string, nickname: string | null };

type FetchClimatesScreenClimateSensorAccessory_ButtonAccessory_Fragment = { __typename: 'ButtonAccessory', id: string, nickname: string | null };

type FetchClimatesScreenClimateSensorAccessory_ClimateSensorAccessory_Fragment = { __typename: 'ClimateSensorAccessory', id: string, nickname: string | null, climate: { id: string } | null };

type FetchClimatesScreenClimateSensorAccessory_GenericAccessory_Fragment = { __typename: 'GenericAccessory', id: string, nickname: string | null };

export type FetchClimatesScreenClimateSensorAccessoryFragment =
  | FetchClimatesScreenClimateSensorAccessory_BridgeAccessory_Fragment
  | FetchClimatesScreenClimateSensorAccessory_ButtonAccessory_Fragment
  | FetchClimatesScreenClimateSensorAccessory_ClimateSensorAccessory_Fragment
  | FetchClimatesScreenClimateSensorAccessory_GenericAccessory_Fragment
;

export type FetchClimatesScreenClimateFragment = { id: string, accessory:
    | { nickname: string | null }
    | { nickname: string | null }
    | { nickname: string | null }
    | { nickname: string | null }
   | null, alarms: Array<{ thresholdType: ClimateAlarmThresholdType, metric: ClimateAlarmMetric, alarmThreshold: number, disabled: boolean }> };

export type FetchClimatesScreenClimateQueryVariables = Exact<{
  climateId: string | number;
}>;


export type FetchClimatesScreenClimateQuery = { climate: { id: string, accessory:
      | { nickname: string | null }
      | { nickname: string | null }
      | { nickname: string | null }
      | { nickname: string | null }
     | null, alarms: Array<{ thresholdType: ClimateAlarmThresholdType, metric: ClimateAlarmMetric, alarmThreshold: number, disabled: boolean }> } | null };

export type FetchClimatesScreenFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchClimatesScreenFilterOptionsQuery = { currentAccount: { statisticsDimensions: Array<
      | { __typename: 'StatisticsCategoricalDimension', key: string, field: string, categories: Array<{ key: string, label: string | null }> | null }
      | { __typename: 'StatisticsDateRangeDimension', from: string | null, to: string | null, key: string, field: string }
     | null> } | null };

type FetchHourlyChartTooltipContentNote_BridgeAccessory_Fragment = { __typename: 'BridgeAccessory' };

type FetchHourlyChartTooltipContentNote_ButtonAccessory_Fragment = { __typename: 'ButtonAccessory' };

type FetchHourlyChartTooltipContentNote_Climate_Fragment = { __typename: 'Climate' };

type FetchHourlyChartTooltipContentNote_ClimateSensorAccessory_Fragment = { __typename: 'ClimateSensorAccessory' };

type FetchHourlyChartTooltipContentNote_Device_Fragment = { __typename: 'Device' };

type FetchHourlyChartTooltipContentNote_GenericAccessory_Fragment = { __typename: 'GenericAccessory' };

type FetchHourlyChartTooltipContentNote_Incident_Fragment = { __typename: 'Incident' };

type FetchHourlyChartTooltipContentNote_Monitor_Fragment = { __typename: 'Monitor' };

type FetchHourlyChartTooltipContentNote_Note_Fragment = { __typename: 'Note', id: string, submittedAt: string, content: string | null };

type FetchHourlyChartTooltipContentNote_Observation_Fragment = { __typename: 'Observation' };

type FetchHourlyChartTooltipContentNote_Presence_Fragment = { __typename: 'Presence' };

type FetchHourlyChartTooltipContentNote_Sound_Fragment = { __typename: 'Sound' };

type FetchHourlyChartTooltipContentNote_User_Fragment = { __typename: 'User' };

export type FetchHourlyChartTooltipContentNoteFragment =
  | FetchHourlyChartTooltipContentNote_BridgeAccessory_Fragment
  | FetchHourlyChartTooltipContentNote_ButtonAccessory_Fragment
  | FetchHourlyChartTooltipContentNote_Climate_Fragment
  | FetchHourlyChartTooltipContentNote_ClimateSensorAccessory_Fragment
  | FetchHourlyChartTooltipContentNote_Device_Fragment
  | FetchHourlyChartTooltipContentNote_GenericAccessory_Fragment
  | FetchHourlyChartTooltipContentNote_Incident_Fragment
  | FetchHourlyChartTooltipContentNote_Monitor_Fragment
  | FetchHourlyChartTooltipContentNote_Note_Fragment
  | FetchHourlyChartTooltipContentNote_Observation_Fragment
  | FetchHourlyChartTooltipContentNote_Presence_Fragment
  | FetchHourlyChartTooltipContentNote_Sound_Fragment
  | FetchHourlyChartTooltipContentNote_User_Fragment
;

export type FetchHourlyChartTooltipContentNotesQueryVariables = Exact<{
  ids: Array<string | number> | string | number;
}>;


export type FetchHourlyChartTooltipContentNotesQuery = { nodes: Array<
    | { __typename: 'BridgeAccessory' }
    | { __typename: 'ButtonAccessory' }
    | { __typename: 'Climate' }
    | { __typename: 'ClimateSensorAccessory' }
    | { __typename: 'Device' }
    | { __typename: 'GenericAccessory' }
    | { __typename: 'Incident' }
    | { __typename: 'Monitor' }
    | { __typename: 'Note', id: string, submittedAt: string, content: string | null }
    | { __typename: 'Observation' }
    | { __typename: 'Presence' }
    | { __typename: 'Sound' }
    | { __typename: 'User' }
   | null> };

export type FetchCarerPresenceListWidgetPresencesQueryVariables = Exact<{
  filters?: PresenceFilters | null | undefined;
}>;


export type FetchCarerPresenceListWidgetPresencesQuery = { currentAccount: { presences: { nodes: Array<{ id: string, startAt: string, duration: string | null, createdByPerson:
          | { name: string | null }
          | { name: string | null }
         | null, createdByDevice: { name: string | null } | null }> } } | null };

export type FetchPresenceScreenFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchPresenceScreenFilterOptionsQuery = { currentAccount: { statisticsDimensions: Array<
      | { __typename: 'StatisticsCategoricalDimension', key: string, field: string, categories: Array<{ key: string, label: string | null, node:
            | { __typename: 'BridgeAccessory' }
            | { __typename: 'ButtonAccessory' }
            | { __typename: 'Climate' }
            | { __typename: 'ClimateSensorAccessory' }
            | { __typename: 'Device' }
            | { __typename: 'GenericAccessory' }
            | { __typename: 'Incident' }
            | { __typename: 'Monitor', routines: Array<{ active: boolean, startTime: string, endTime: string }> }
            | { __typename: 'Note' }
            | { __typename: 'Observation' }
            | { __typename: 'Presence' }
            | { __typename: 'Sound' }
            | { __typename: 'User' }
           | null }> | null }
      | { __typename: 'StatisticsDateRangeDimension', from: string | null, to: string | null, key: string, field: string }
     | null> } | null };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const AccessoryStatusIndicatorAccessoryFragmentDoc = new TypedDocumentString(`
    fragment AccessoryStatusIndicatorAccessory on Accessory {
  operationStatus
}
    `, {"fragmentName":"AccessoryStatusIndicatorAccessory"});
export const MonitorStatusIndicatorMonitorFragmentDoc = new TypedDocumentString(`
    fragment MonitorStatusIndicatorMonitor on Monitor {
  operationStatus
  charging
}
    `, {"fragmentName":"MonitorStatusIndicatorMonitor"});
export const CurrentAccountFragmentDoc = new TypedDocumentString(`
    fragment CurrentAccount on Account {
  id
  features
}
    `, {"fragmentName":"CurrentAccount"});
export const DeviceOptionFragmentDoc = new TypedDocumentString(`
    fragment DeviceOption on Device {
  id
  name
}
    `, {"fragmentName":"DeviceOption"});
export const MonitorOptionFragmentDoc = new TypedDocumentString(`
    fragment MonitorOption on Monitor {
  id
  nickname
}
    `, {"fragmentName":"MonitorOption"});
export const StaffOptionFragmentDoc = new TypedDocumentString(`
    fragment StaffOption on Staff {
  id
  name
}
    `, {"fragmentName":"StaffOption"});
export const StatusScreenNestedLocationFragmentDoc = new TypedDocumentString(`
    fragment StatusScreenNestedLocation on Location {
  id
  name
}
    `, {"fragmentName":"StatusScreenNestedLocation"});
export const StatusScreenMonitorFragmentDoc = new TypedDocumentString(`
    fragment StatusScreenMonitor on Monitor {
  __typename
  id
  nickname
  charging
  operational
  operationStatus
  location {
    ...StatusScreenNestedLocation
  }
  sounds: selectedSounds {
    slug
    name
    svg_icon_url: iconUrl(fileType: SVG)
  }
  observations: recentObservations {
    observation_type: observationType
    sound {
      slug
      name
      svg_icon_url: iconUrl(fileType: SVG)
    }
  }
}
    fragment StatusScreenNestedLocation on Location {
  id
  name
}`, {"fragmentName":"StatusScreenMonitor"});
export const StatusScreenNestedMonitorFragmentDoc = new TypedDocumentString(`
    fragment StatusScreenNestedMonitor on Monitor {
  id
  nickname
}
    `, {"fragmentName":"StatusScreenNestedMonitor"});
export const StatusScreenAccessoryFragmentDoc = new TypedDocumentString(`
    fragment StatusScreenAccessory on Accessory {
  __typename
  id
  nickname
  operational
  operationStatus
  location {
    ...StatusScreenNestedLocation
  }
  monitor {
    ...StatusScreenNestedMonitor
  }
  parentAccessory {
    id
    operationStatus
  }
  ... on ClimateSensorAccessory {
    climate {
      id
      temperature
      alarms {
        id
        metric
        currentStatus
        disabled
        metric
        thresholdType
        alarmThreshold
      }
    }
  }
  ... on ButtonAccessory {
    gestureActions {
      gesture
      action
    }
    latestCall {
      startAt
    }
  }
}
    fragment StatusScreenNestedLocation on Location {
  id
  name
}
fragment StatusScreenNestedMonitor on Monitor {
  id
  nickname
}`, {"fragmentName":"StatusScreenAccessory"});
export const KanbanEventMonitorFragmentDoc = new TypedDocumentString(`
    fragment KanbanEventMonitor on Monitor {
  id
  nickname
}
    `, {"fragmentName":"KanbanEventMonitor"});
export const KanbanSoundEventFragmentDoc = new TypedDocumentString(`
    fragment KanbanSoundEvent on DashboardKanbanSoundEvent {
  __typename
  sound {
    slug
    svg_icon_url: iconUrl(fileType: SVG)
    name
  }
  monitor {
    ...KanbanEventMonitor
  }
  attendanceStatus
  createdAt
  notificationImportance
}
    fragment KanbanEventMonitor on Monitor {
  id
  nickname
}`, {"fragmentName":"KanbanSoundEvent"});
export const KanbanAttendanceEventFragmentDoc = new TypedDocumentString(`
    fragment KanbanAttendanceEvent on DashboardKanbanAttendanceEvent {
  __typename
  monitor {
    ...KanbanEventMonitor
  }
  createdAt
  attendanceStatus
  isPhysicalAttendance
}
    fragment KanbanEventMonitor on Monitor {
  id
  nickname
}`, {"fragmentName":"KanbanAttendanceEvent"});
export const KanbanCallEventFragmentDoc = new TypedDocumentString(`
    fragment KanbanCallEvent on DashboardKanbanCallEvent {
  __typename
  monitor {
    ...KanbanEventMonitor
  }
  createdAt
  attendanceStatus
}
    fragment KanbanEventMonitor on Monitor {
  id
  nickname
}`, {"fragmentName":"KanbanCallEvent"});
export const KanbanEventFragmentDoc = new TypedDocumentString(`
    fragment KanbanEvent on DashboardKanbanEvent {
  __typename
  ...KanbanSoundEvent
  ...KanbanAttendanceEvent
  ...KanbanCallEvent
}
    fragment KanbanEventMonitor on Monitor {
  id
  nickname
}
fragment KanbanSoundEvent on DashboardKanbanSoundEvent {
  __typename
  sound {
    slug
    svg_icon_url: iconUrl(fileType: SVG)
    name
  }
  monitor {
    ...KanbanEventMonitor
  }
  attendanceStatus
  createdAt
  notificationImportance
}
fragment KanbanAttendanceEvent on DashboardKanbanAttendanceEvent {
  __typename
  monitor {
    ...KanbanEventMonitor
  }
  createdAt
  attendanceStatus
  isPhysicalAttendance
}
fragment KanbanCallEvent on DashboardKanbanCallEvent {
  __typename
  monitor {
    ...KanbanEventMonitor
  }
  createdAt
  attendanceStatus
}`, {"fragmentName":"KanbanEvent"});
export const IStatisticsDimensionGroupByFragmentDoc = new TypedDocumentString(`
    fragment IStatisticsDimensionGroupBy on StatisticsDimension {
  __typename
  key
}
    `, {"fragmentName":"IStatisticsDimensionGroupBy"});
export const IStatisticsCategoricalDimensionCategoryFragmentDoc = new TypedDocumentString(`
    fragment IStatisticsCategoricalDimensionCategory on StatisticsCategoricalDimensionCategory {
  label
}
    `, {"fragmentName":"IStatisticsCategoricalDimensionCategory"});
export const IStatisticsDimensionSortCategoryLabelFragmentDoc = new TypedDocumentString(`
    fragment IStatisticsDimensionSortCategoryLabel on StatisticsDimension {
  ... on StatisticsCategoricalDimension {
    categories {
      ...IStatisticsCategoricalDimensionCategory
    }
  }
}
    fragment IStatisticsCategoricalDimensionCategory on StatisticsCategoricalDimensionCategory {
  label
}`, {"fragmentName":"IStatisticsDimensionSortCategoryLabel"});
export const IStatisticsDimensionDateRangeFragmentDoc = new TypedDocumentString(`
    fragment IStatisticsDimensionDateRange on StatisticsDimension {
  ... on StatisticsDateRangeDimension {
    from
    to
  }
}
    `, {"fragmentName":"IStatisticsDimensionDateRange"});
export const FetchAcousticsMonitorScreenIncidentListWidgetIncidentFragmentDoc = new TypedDocumentString(`
    fragment FetchAcousticsMonitorScreenIncidentListWidgetIncident on Incident {
  id
  category
  locationDescription
  note
  occurredAt
}
    `, {"fragmentName":"FetchAcousticsMonitorScreenIncidentListWidgetIncident"});
export const FetchAcousticsMonitorScreenNoteListWidgetNoteFragmentDoc = new TypedDocumentString(`
    fragment FetchAcousticsMonitorScreenNoteListWidgetNote on Note {
  id
  title
  content
  category
  submittedAt
  createdByPerson {
    name
  }
  createdByDevice {
    name
  }
}
    `, {"fragmentName":"FetchAcousticsMonitorScreenNoteListWidgetNote"});
export const FetchAcousticsMonitorScreenObservationListWidgetObservationFragmentDoc = new TypedDocumentString(`
    fragment FetchAcousticsMonitorScreenObservationListWidgetObservation on Observation {
  id
  observationType
  startAt
  endAt
  createdAt
  sound {
    slug
    name
    svg_icon_url: iconUrl(fileType: SVG)
  }
}
    `, {"fragmentName":"FetchAcousticsMonitorScreenObservationListWidgetObservation"});
export const FetchAcousticsOverviewScreenObservationListWidgetObservationFragmentDoc = new TypedDocumentString(`
    fragment FetchAcousticsOverviewScreenObservationListWidgetObservation on Observation {
  id
  observationType
  startAt
  endAt
  createdAt
  monitor {
    id
    nickname
  }
  sound {
    slug
    name
    svg_icon_url: iconUrl(fileType: SVG)
  }
}
    `, {"fragmentName":"FetchAcousticsOverviewScreenObservationListWidgetObservation"});
export const FetchClimatesScreenClimateSensorAccessoryFragmentDoc = new TypedDocumentString(`
    fragment FetchClimatesScreenClimateSensorAccessory on Accessory {
  __typename
  id
  nickname
  ... on ClimateSensorAccessory {
    climate {
      id
    }
  }
}
    `, {"fragmentName":"FetchClimatesScreenClimateSensorAccessory"});
export const FetchClimatesScreenClimateFragmentDoc = new TypedDocumentString(`
    fragment FetchClimatesScreenClimate on Climate {
  id
  accessory {
    nickname
  }
  alarms {
    thresholdType
    metric
    alarmThreshold
    disabled
  }
}
    `, {"fragmentName":"FetchClimatesScreenClimate"});
export const FetchHourlyChartTooltipContentNoteFragmentDoc = new TypedDocumentString(`
    fragment FetchHourlyChartTooltipContentNote on Node {
  __typename
  ... on Note {
    id
    submittedAt
    content
  }
}
    `, {"fragmentName":"FetchHourlyChartTooltipContentNote"});
export const FetchCurrentAccountDocument = new TypedDocumentString(`
    query FetchCurrentAccount {
  currentAccount {
    ...CurrentAccount
  }
}
    fragment CurrentAccount on Account {
  id
  features
}`);
export const FetchDeviceOptionsDocument = new TypedDocumentString(`
    query FetchDeviceOptions {
  currentAccount {
    deviceOptions: devices {
      nodes {
        ...DeviceOption
      }
    }
  }
}
    fragment DeviceOption on Device {
  id
  name
}`);
export const FetchMonitorOptionsDocument = new TypedDocumentString(`
    query FetchMonitorOptions {
  monitorOptions: monitors {
    nodes {
      ...MonitorOption
    }
  }
}
    fragment MonitorOption on Monitor {
  id
  nickname
}`);
export const FetchMonitorOptionDocument = new TypedDocumentString(`
    query FetchMonitorOption($id: ID!) {
  monitorOption: monitor(id: $id) {
    ...MonitorOption
  }
}
    fragment MonitorOption on Monitor {
  id
  nickname
}`);
export const FetchStaffOptionsDocument = new TypedDocumentString(`
    query FetchStaffOptions {
  currentAccount {
    staffOptions: staffList {
      nodes {
        ...StaffOption
      }
    }
  }
}
    fragment StaffOption on Staff {
  id
  name
}`);
export const FetchStatusScreenDataDocument = new TypedDocumentString(`
    query FetchStatusScreenData($accountId: ID!) {
  account(id: $accountId) {
    dashboard {
      connectedDevicesCount
      averageResponseTime
      responseCount
    }
    monitors {
      nodes {
        ...StatusScreenMonitor
      }
    }
    accessories {
      nodes {
        ...StatusScreenAccessory
      }
    }
  }
}
    fragment StatusScreenNestedLocation on Location {
  id
  name
}
fragment StatusScreenNestedMonitor on Monitor {
  id
  nickname
}
fragment StatusScreenMonitor on Monitor {
  __typename
  id
  nickname
  charging
  operational
  operationStatus
  location {
    ...StatusScreenNestedLocation
  }
  sounds: selectedSounds {
    slug
    name
    svg_icon_url: iconUrl(fileType: SVG)
  }
  observations: recentObservations {
    observation_type: observationType
    sound {
      slug
      name
      svg_icon_url: iconUrl(fileType: SVG)
    }
  }
}
fragment StatusScreenAccessory on Accessory {
  __typename
  id
  nickname
  operational
  operationStatus
  location {
    ...StatusScreenNestedLocation
  }
  monitor {
    ...StatusScreenNestedMonitor
  }
  parentAccessory {
    id
    operationStatus
  }
  ... on ClimateSensorAccessory {
    climate {
      id
      temperature
      alarms {
        id
        metric
        currentStatus
        disabled
        metric
        thresholdType
        alarmThreshold
      }
    }
  }
  ... on ButtonAccessory {
    gestureActions {
      gesture
      action
    }
    latestCall {
      startAt
    }
  }
}`);
export const SubscribeStatusScreenMonitorDataDocument = new TypedDocumentString(`
    subscription SubscribeStatusScreenMonitorData($accountId: ID!) {
  monitorEventsCreated(input: {accountId: $accountId}) {
    monitor {
      id
      charging
      operational
      operationStatus
    }
  }
}
    `);
export const SubscribeStatusScreenStatusUpdatesDataDocument = new TypedDocumentString(`
    subscription SubscribeStatusScreenStatusUpdatesData($accountId: ID!) {
  accountStatusUpdates(input: {accountId: $accountId}) {
    __typename
    accountId
    ... on AccountStatusUpdatesSubscriptionAccessoryPayload {
      accessoryId
      operational
      operationStatus
    }
    ... on AccountStatusUpdatesSubscriptionClimatePayload {
      climateAccessoryId: accessoryId
      temperature
    }
    ... on AccountStatusUpdatesSubscriptionClimateAlarmPayload {
      climateAlarmId
      currentStatus
    }
    ... on AccountStatusUpdatesSubscriptionMonitorPayload {
      monitorId
      charging
      operational
      monitorOperationStatus: operationStatus
    }
  }
}
    `);
export const FetchKanbanMonitorsDocument = new TypedDocumentString(`
    query FetchKanbanMonitors($accountId: ID!) {
  account(id: $accountId) {
    monitors {
      nodes {
        id
        operational
      }
    }
  }
}
    `);
export const SubscribeKanbanMonitorsDocument = new TypedDocumentString(`
    subscription SubscribeKanbanMonitors($accountId: ID!) {
  monitorEventsCreated(input: {accountId: $accountId}) {
    monitor {
      id
      operational
    }
  }
}
    `);
export const FetchKanbanScreenEventsDocument = new TypedDocumentString(`
    query FetchKanbanScreenEvents {
  currentAccount {
    dashboard {
      kanban {
        events {
          ...KanbanEvent
        }
      }
    }
  }
}
    fragment KanbanEventMonitor on Monitor {
  id
  nickname
}
fragment KanbanSoundEvent on DashboardKanbanSoundEvent {
  __typename
  sound {
    slug
    svg_icon_url: iconUrl(fileType: SVG)
    name
  }
  monitor {
    ...KanbanEventMonitor
  }
  attendanceStatus
  createdAt
  notificationImportance
}
fragment KanbanAttendanceEvent on DashboardKanbanAttendanceEvent {
  __typename
  monitor {
    ...KanbanEventMonitor
  }
  createdAt
  attendanceStatus
  isPhysicalAttendance
}
fragment KanbanCallEvent on DashboardKanbanCallEvent {
  __typename
  monitor {
    ...KanbanEventMonitor
  }
  createdAt
  attendanceStatus
}
fragment KanbanEvent on DashboardKanbanEvent {
  __typename
  ...KanbanSoundEvent
  ...KanbanAttendanceEvent
  ...KanbanCallEvent
}`);
export const SubscribeKanbanScreenEventsDocument = new TypedDocumentString(`
    subscription SubscribeKanbanScreenEvents($accountId: ID!) {
  dashboardKanbanEventsCreated(accountId: $accountId) {
    ...KanbanEvent
  }
}
    fragment KanbanEventMonitor on Monitor {
  id
  nickname
}
fragment KanbanSoundEvent on DashboardKanbanSoundEvent {
  __typename
  sound {
    slug
    svg_icon_url: iconUrl(fileType: SVG)
    name
  }
  monitor {
    ...KanbanEventMonitor
  }
  attendanceStatus
  createdAt
  notificationImportance
}
fragment KanbanAttendanceEvent on DashboardKanbanAttendanceEvent {
  __typename
  monitor {
    ...KanbanEventMonitor
  }
  createdAt
  attendanceStatus
  isPhysicalAttendance
}
fragment KanbanCallEvent on DashboardKanbanCallEvent {
  __typename
  monitor {
    ...KanbanEventMonitor
  }
  createdAt
  attendanceStatus
}
fragment KanbanEvent on DashboardKanbanEvent {
  __typename
  ...KanbanSoundEvent
  ...KanbanAttendanceEvent
  ...KanbanCallEvent
}`);
export const FetchAcousticsMonitorScreenIncidentListWidgetIncidentsDocument = new TypedDocumentString(`
    query FetchAcousticsMonitorScreenIncidentListWidgetIncidents($filters: IncidentFilters) {
  currentAccount {
    incidents(filters: $filters) {
      nodes {
        ...FetchAcousticsMonitorScreenIncidentListWidgetIncident
      }
    }
  }
}
    fragment FetchAcousticsMonitorScreenIncidentListWidgetIncident on Incident {
  id
  category
  locationDescription
  note
  occurredAt
}`);
export const FetchAcousticsMonitorScreenNoteListWidgetNotesDocument = new TypedDocumentString(`
    query FetchAcousticsMonitorScreenNoteListWidgetNotes($filters: NoteFilters) {
  currentAccount {
    notes(filters: $filters) {
      nodes {
        ...FetchAcousticsMonitorScreenNoteListWidgetNote
      }
    }
  }
}
    fragment FetchAcousticsMonitorScreenNoteListWidgetNote on Note {
  id
  title
  content
  category
  submittedAt
  createdByPerson {
    name
  }
  createdByDevice {
    name
  }
}`);
export const FetchAcousticsMonitorScreenObservationListWidgetObservationsDocument = new TypedDocumentString(`
    query FetchAcousticsMonitorScreenObservationListWidgetObservations($filters: ObservationFilters) {
  currentAccount {
    observations(filters: $filters, reverse: true) {
      nodes {
        ...FetchAcousticsMonitorScreenObservationListWidgetObservation
      }
    }
  }
}
    fragment FetchAcousticsMonitorScreenObservationListWidgetObservation on Observation {
  id
  observationType
  startAt
  endAt
  createdAt
  sound {
    slug
    name
    svg_icon_url: iconUrl(fileType: SVG)
  }
}`);
export const FetchAcousticsOverviewScreenObservationListWidgetObservationsDocument = new TypedDocumentString(`
    query FetchAcousticsOverviewScreenObservationListWidgetObservations($filters: ObservationFilters, $first: Int) {
  currentAccount {
    observations(filters: $filters, first: $first, reverse: true) {
      nodes {
        ...FetchAcousticsOverviewScreenObservationListWidgetObservation
      }
    }
  }
}
    fragment FetchAcousticsOverviewScreenObservationListWidgetObservation on Observation {
  id
  observationType
  startAt
  endAt
  createdAt
  monitor {
    id
    nickname
  }
  sound {
    slug
    name
    svg_icon_url: iconUrl(fileType: SVG)
  }
}`);
export const FetchAcousticsScreenFilterOptionsDocument = new TypedDocumentString(`
    query FetchAcousticsScreenFilterOptions {
  currentAccount {
    statisticsDimensions(
      measure: "events.count"
      dimensions: [{field: "date_time.", key: "datetime"}, {field: "monitor.id", key: "monitors"}]
    ) {
      __typename
      key
      field
      ... on StatisticsDateRangeDimension {
        from
        to
      }
      ... on StatisticsCategoricalDimension {
        categories {
          key
          label
          node {
            __typename
            ... on Monitor {
              routines {
                active
                startTime
                endTime
              }
            }
          }
        }
      }
    }
  }
}
    `);
export const FetchAidCallOverviewScreenFilterOptionsDocument = new TypedDocumentString(`
    query FetchAidCallOverviewScreenFilterOptions {
  currentAccount {
    statisticsDimensions(
      measure: "aidcall.count"
      dimensions: [{field: "date_time.", key: "datetime"}, {field: "monitor.id", key: "monitors"}]
    ) {
      __typename
      key
      field
      ... on StatisticsDateRangeDimension {
        from
        to
      }
      ... on StatisticsCategoricalDimension {
        categories {
          key
          label
        }
      }
    }
  }
}
    `);
export const FetchClimatesOverviewScreenClimatesDocument = new TypedDocumentString(`
    query FetchClimatesOverviewScreenClimates {
  account: currentAccount {
    climates {
      nodes {
        ...FetchClimatesScreenClimate
      }
    }
  }
}
    fragment FetchClimatesScreenClimate on Climate {
  id
  accessory {
    nickname
  }
  alarms {
    thresholdType
    metric
    alarmThreshold
    disabled
  }
}`);
export const FetchClimatesScreenClimateDocument = new TypedDocumentString(`
    query FetchClimatesScreenClimate($climateId: ID!) {
  climate(id: $climateId) {
    ...FetchClimatesScreenClimate
  }
}
    fragment FetchClimatesScreenClimate on Climate {
  id
  accessory {
    nickname
  }
  alarms {
    thresholdType
    metric
    alarmThreshold
    disabled
  }
}`);
export const FetchClimatesScreenFilterOptionsDocument = new TypedDocumentString(`
    query FetchClimatesScreenFilterOptions {
  currentAccount {
    statisticsDimensions(
      measure: "temperature.avg"
      dimensions: [{field: "date_time.", key: "datetime"}, {field: "climate.id", key: "climates"}]
    ) {
      __typename
      key
      field
      ... on StatisticsDateRangeDimension {
        from
        to
      }
      ... on StatisticsCategoricalDimension {
        categories {
          key
          label
        }
      }
    }
  }
}
    `);
export const FetchHourlyChartTooltipContentNotesDocument = new TypedDocumentString(`
    query FetchHourlyChartTooltipContentNotes($ids: [ID!]!) {
  nodes(ids: $ids) {
    ...FetchHourlyChartTooltipContentNote
  }
}
    fragment FetchHourlyChartTooltipContentNote on Node {
  __typename
  ... on Note {
    id
    submittedAt
    content
  }
}`);
export const FetchCarerPresenceListWidgetPresencesDocument = new TypedDocumentString(`
    query FetchCarerPresenceListWidgetPresences($filters: PresenceFilters) {
  currentAccount {
    presences(filters: $filters, reverse: true) {
      nodes {
        id
        startAt
        duration
        createdByPerson {
          name
        }
        createdByDevice {
          name
        }
      }
    }
  }
}
    `);
export const FetchPresenceScreenFilterOptionsDocument = new TypedDocumentString(`
    query FetchPresenceScreenFilterOptions {
  currentAccount {
    statisticsDimensions(
      measure: "events.count"
      dimensions: [{field: "date_time.", key: "datetime"}, {field: "monitor.id", key: "monitors"}]
    ) {
      __typename
      key
      field
      ... on StatisticsDateRangeDimension {
        from
        to
      }
      ... on StatisticsCategoricalDimension {
        categories {
          key
          label
          node {
            __typename
            ... on Monitor {
              routines {
                active
                startTime
                endTime
              }
            }
          }
        }
      }
    }
  }
}
    `);

const injectedRtkApi = emptyGraphqlApi.injectEndpoints({
  endpoints: (build) => ({
    FetchCurrentAccount: build.query<FetchCurrentAccountQuery, FetchCurrentAccountQueryVariables | void>({
      query: (variables) => ({ document: FetchCurrentAccountDocument as unknown as string, variables })
    }),
    FetchDeviceOptions: build.query<FetchDeviceOptionsQuery, FetchDeviceOptionsQueryVariables | void>({
      query: (variables) => ({ document: FetchDeviceOptionsDocument as unknown as string, variables })
    }),
    FetchMonitorOptions: build.query<FetchMonitorOptionsQuery, FetchMonitorOptionsQueryVariables | void>({
      query: (variables) => ({ document: FetchMonitorOptionsDocument as unknown as string, variables })
    }),
    FetchMonitorOption: build.query<FetchMonitorOptionQuery, FetchMonitorOptionQueryVariables>({
      query: (variables) => ({ document: FetchMonitorOptionDocument as unknown as string, variables })
    }),
    FetchStaffOptions: build.query<FetchStaffOptionsQuery, FetchStaffOptionsQueryVariables | void>({
      query: (variables) => ({ document: FetchStaffOptionsDocument as unknown as string, variables })
    }),
    FetchStatusScreenData: build.query<FetchStatusScreenDataQuery, FetchStatusScreenDataQueryVariables>({
      query: (variables) => ({ document: FetchStatusScreenDataDocument as unknown as string, variables })
    }),
    FetchKanbanMonitors: build.query<FetchKanbanMonitorsQuery, FetchKanbanMonitorsQueryVariables>({
      query: (variables) => ({ document: FetchKanbanMonitorsDocument as unknown as string, variables })
    }),
    FetchKanbanScreenEvents: build.query<FetchKanbanScreenEventsQuery, FetchKanbanScreenEventsQueryVariables | void>({
      query: (variables) => ({ document: FetchKanbanScreenEventsDocument as unknown as string, variables })
    }),
    FetchAcousticsMonitorScreenIncidentListWidgetIncidents: build.query<FetchAcousticsMonitorScreenIncidentListWidgetIncidentsQuery, FetchAcousticsMonitorScreenIncidentListWidgetIncidentsQueryVariables | void>({
      query: (variables) => ({ document: FetchAcousticsMonitorScreenIncidentListWidgetIncidentsDocument as unknown as string, variables })
    }),
    FetchAcousticsMonitorScreenNoteListWidgetNotes: build.query<FetchAcousticsMonitorScreenNoteListWidgetNotesQuery, FetchAcousticsMonitorScreenNoteListWidgetNotesQueryVariables | void>({
      query: (variables) => ({ document: FetchAcousticsMonitorScreenNoteListWidgetNotesDocument as unknown as string, variables })
    }),
    FetchAcousticsMonitorScreenObservationListWidgetObservations: build.query<FetchAcousticsMonitorScreenObservationListWidgetObservationsQuery, FetchAcousticsMonitorScreenObservationListWidgetObservationsQueryVariables | void>({
      query: (variables) => ({ document: FetchAcousticsMonitorScreenObservationListWidgetObservationsDocument as unknown as string, variables })
    }),
    FetchAcousticsOverviewScreenObservationListWidgetObservations: build.query<FetchAcousticsOverviewScreenObservationListWidgetObservationsQuery, FetchAcousticsOverviewScreenObservationListWidgetObservationsQueryVariables | void>({
      query: (variables) => ({ document: FetchAcousticsOverviewScreenObservationListWidgetObservationsDocument as unknown as string, variables })
    }),
    FetchAcousticsScreenFilterOptions: build.query<FetchAcousticsScreenFilterOptionsQuery, FetchAcousticsScreenFilterOptionsQueryVariables | void>({
      query: (variables) => ({ document: FetchAcousticsScreenFilterOptionsDocument as unknown as string, variables })
    }),
    FetchAidCallOverviewScreenFilterOptions: build.query<FetchAidCallOverviewScreenFilterOptionsQuery, FetchAidCallOverviewScreenFilterOptionsQueryVariables | void>({
      query: (variables) => ({ document: FetchAidCallOverviewScreenFilterOptionsDocument as unknown as string, variables })
    }),
    FetchClimatesOverviewScreenClimates: build.query<FetchClimatesOverviewScreenClimatesQuery, FetchClimatesOverviewScreenClimatesQueryVariables | void>({
      query: (variables) => ({ document: FetchClimatesOverviewScreenClimatesDocument as unknown as string, variables })
    }),
    FetchClimatesScreenClimate: build.query<FetchClimatesScreenClimateQuery, FetchClimatesScreenClimateQueryVariables>({
      query: (variables) => ({ document: FetchClimatesScreenClimateDocument as unknown as string, variables })
    }),
    FetchClimatesScreenFilterOptions: build.query<FetchClimatesScreenFilterOptionsQuery, FetchClimatesScreenFilterOptionsQueryVariables | void>({
      query: (variables) => ({ document: FetchClimatesScreenFilterOptionsDocument as unknown as string, variables })
    }),
    FetchHourlyChartTooltipContentNotes: build.query<FetchHourlyChartTooltipContentNotesQuery, FetchHourlyChartTooltipContentNotesQueryVariables>({
      query: (variables) => ({ document: FetchHourlyChartTooltipContentNotesDocument as unknown as string, variables })
    }),
    FetchCarerPresenceListWidgetPresences: build.query<FetchCarerPresenceListWidgetPresencesQuery, FetchCarerPresenceListWidgetPresencesQueryVariables | void>({
      query: (variables) => ({ document: FetchCarerPresenceListWidgetPresencesDocument as unknown as string, variables })
    }),
    FetchPresenceScreenFilterOptions: build.query<FetchPresenceScreenFilterOptionsQuery, FetchPresenceScreenFilterOptionsQueryVariables | void>({
      query: (variables) => ({ document: FetchPresenceScreenFilterOptionsDocument as unknown as string, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useFetchCurrentAccountQuery, useLazyFetchCurrentAccountQuery, useFetchDeviceOptionsQuery, useLazyFetchDeviceOptionsQuery, useFetchMonitorOptionsQuery, useLazyFetchMonitorOptionsQuery, useFetchMonitorOptionQuery, useLazyFetchMonitorOptionQuery, useFetchStaffOptionsQuery, useLazyFetchStaffOptionsQuery, useFetchStatusScreenDataQuery, useLazyFetchStatusScreenDataQuery, useFetchKanbanMonitorsQuery, useLazyFetchKanbanMonitorsQuery, useFetchKanbanScreenEventsQuery, useLazyFetchKanbanScreenEventsQuery, useFetchAcousticsMonitorScreenIncidentListWidgetIncidentsQuery, useLazyFetchAcousticsMonitorScreenIncidentListWidgetIncidentsQuery, useFetchAcousticsMonitorScreenNoteListWidgetNotesQuery, useLazyFetchAcousticsMonitorScreenNoteListWidgetNotesQuery, useFetchAcousticsMonitorScreenObservationListWidgetObservationsQuery, useLazyFetchAcousticsMonitorScreenObservationListWidgetObservationsQuery, useFetchAcousticsOverviewScreenObservationListWidgetObservationsQuery, useLazyFetchAcousticsOverviewScreenObservationListWidgetObservationsQuery, useFetchAcousticsScreenFilterOptionsQuery, useLazyFetchAcousticsScreenFilterOptionsQuery, useFetchAidCallOverviewScreenFilterOptionsQuery, useLazyFetchAidCallOverviewScreenFilterOptionsQuery, useFetchClimatesOverviewScreenClimatesQuery, useLazyFetchClimatesOverviewScreenClimatesQuery, useFetchClimatesScreenClimateQuery, useLazyFetchClimatesScreenClimateQuery, useFetchClimatesScreenFilterOptionsQuery, useLazyFetchClimatesScreenFilterOptionsQuery, useFetchHourlyChartTooltipContentNotesQuery, useLazyFetchHourlyChartTooltipContentNotesQuery, useFetchCarerPresenceListWidgetPresencesQuery, useLazyFetchCarerPresenceListWidgetPresencesQuery, useFetchPresenceScreenFilterOptionsQuery, useLazyFetchPresenceScreenFilterOptionsQuery } = injectedRtkApi;

